export const countCharacter = (character: string) => (input: string) =>
  input.split(character).length - 1;
